<template>
  <div>
    {{$t("views.excmnotificationmessage.legend.legend")}}:
    <ul>
      <li>{{$t("views.excmnotificationmessage.legend.id_case")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.id_task")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.project_date")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.order_list")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.warehouse")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.case_type")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.client_name")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.client_address")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.client_email")}}</li>
      <li>{{$t("views.excmnotificationmessage.legend.client_phone")}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'contentFieldLegend'
}
</script>
